import { Row, Card, Col, CardBody, CardTitle } from "reactstrap";
import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const money = (n) => `MVR ${Number(n || 0).toFixed(2)}`;

const Topup = ({
  error,
  goToMyVessels,
  topupAmount,
  setTopupAmount,
  handleTopup,
  walletTaxRate = 0,
}) => {
  const [confirmDlg, setConfirmDlg] = useState(false);

  // GST is charged once, here, when money enters the wallet — spending it
  // later is untaxed. Showing the breakdown up front so the amount debited
  // at the gateway is never a surprise.
  const subtotal = Number(topupAmount) || 0;
  const gst = Math.round(subtotal * walletTaxRate * 100) / 100;
  const total = Math.round((subtotal + gst) * 100) / 100;

  return (
    <React.Fragment>
      <button
        className="btn btn-primary fs-6 py-1"
        onClick={() => goToMyVessels()}
      >
        <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
        <span className="">Back</span>
      </button>
      <Card className="px-3 py-1 mt-4 mb-3">
        <Col>
          <h4 className="pt-3 font-weight-semibold ">Top-up Account</h4>
        </Col>
        <Row>
          <Col className="col-12">
            <label className="col-md-2 col-form-label">Amount</label>
          </Col>
          <Col className="col-md-4 col-lg-4 col-xl-3">
            <input
              className="form-control"
              type="number"
              value={topupAmount}
              onChange={(e) => setTopupAmount(e.target.value)}
            />
          </Col>
        </Row>
        <Col>
          <Row>
            <Col className="col-md-4 col-lg-4 col-xl-3">
              <div className="mt-4 pt-2 mb-3">
                <button
                  className="btn btn-primary fs-6 w-100"
                  onClick={() => setConfirmDlg(true)}
                >
                  <span className="mdi mdi-check align-middle fs-3 me-2"></span>
                  <span className="">Submit</span>
                </button>
              </div>
            </Col>
          </Row>
        </Col>
        {error.Message && error.Message.length > 0 ? (
          <Col>
            <Card color="danger" className="text-white-50">
              <CardBody className="p-3">
                <CardTitle className="mb-2 text-white">
                  <i className="mdi mdi-block-helper me-3" />
                  Error
                </CardTitle>
                <span className="text-white">{error.Message}</span>
              </CardBody>
            </Card>
          </Col>
        ) : null}
      </Card>

      {confirmDlg && (
        <SweetAlert
          showCancel
          confirmBtnText="Confirm & Pay"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="secondary"
          title="Confirm Top-up"
          onConfirm={() => { setConfirmDlg(false); handleTopup(); }}
          onCancel={() => setConfirmDlg(false)}
        >
          <div className="text-start px-2">
            <div className="d-flex justify-content-between py-1">
              <span className="text-muted">Wallet credit</span>
              <span>{money(subtotal)}</span>
            </div>
            <div className="d-flex justify-content-between py-1">
              <span className="text-muted">GST ({(walletTaxRate * 100).toFixed(0)}%)</span>
              <span>{money(gst)}</span>
            </div>
            <hr className="my-2" />
            <div className="d-flex justify-content-between py-1">
              <span className="fw-bold">Payable now</span>
              <span className="fw-bold fs-5 text-primary">{money(total)}</span>
            </div>
            <div className="text-muted mt-3" style={{ fontSize: "0.85em" }}>
              {money(subtotal)} will be credited to your Top-up balance. GST is
              applied to Top-up only. You will be redirected to the payment
              gateway.
            </div>
          </div>
        </SweetAlert>
      )}
    </React.Fragment>
  );
};
export default Topup;
